$(document).ready(function() {
    // Sprungmarken
    $('.ttgSprungmarke').click(function() {
        var target = $(this).attr('data-id');
        $('#' + target).animatescroll({
            padding: 85
        });
    });

    /*** Beschreibungstext kürzen ***/
    if ($('.ttgReadMoreDescription').length) {

        $('.ttgReadMoreDescription').Cuttr({
            licenseKey: 'CAB43BE5-33FE49AD-8F954B7F-42699907',
            truncate: 'words',
            ending: '...',
            readMore: true,
            readMoreText: $(".ttgReadMoreDescription").attr("data-showDescriptionText"),
            readMoreBtnTag: 'button',
            readMoreBtnSelectorClass: 'cuttr__readmore'
        });

        $('body').on('click', '.cuttr__readmore', function() {
            $(this).remove();
        });
    }
    /*** Beschreibungstext kürzen ***/
});

(function($) {

    $.fn.shuffle = function() {

        var allElems = this.get(),
            getRandom = function(max) {
                return Math.floor(Math.random() * max);
            },
            shuffled = $.map(allElems, function() {
                var random = getRandom(allElems.length),
                    randEl = $(allElems[random]).clone(true)[0];
                allElems.splice(random, 1);
                return randEl;
            });

        this.each(function(i) {
            $(this).replaceWith($(shuffled[i]));
        });

        return $(shuffled);

    };

    /*** Indikatoren bei Slick-Slidern einfärben ***/
    window.color_indicators = function(index, indicators, slidesToShow) {
        if ($(window).width() <= 992) {
            slidesToShow = 1;
        }

        indicators.find("li.active").removeClass("active");
        indicators.find("li.active-secondary").removeClass("active-secondary");
        indicators.find("li.active-adjacent").removeClass("active-adjacent");

        indicators.find("li:nth-child(" + index + ")").addClass("active");
        console.log('%cTTG Debug', 'background: #0080a3; color: #fff; padding: 5px;', indicators.find("li:nth-child(" + index + ")"));

        var i = 1;
        while (i < slidesToShow) {
            indicators.find("li:nth-child(" + (index + i) + ")").addClass("active-secondary");
            i++;
        }

        indicators.find("li:nth-child(" + (index + slidesToShow) + ")").addClass("active-adjacent");
        indicators.find("li:nth-child(" + (index + slidesToShow + 1) + ")").addClass("active-adjacent");
        indicators.find("li.active").prev().addClass("active-adjacent");
        indicators.find("li.active").prev().prev().addClass("active-adjacent");
    };
})(jQuery);
